import { arr2table, parseUrl } from '@/utils/helper'
import { modulePath } from '@/utils/auth'
import { getListUserFuncs, getListMenuByFunc } from '@/api/login'
import { getIndexPermission } from '@/api/index'
import { checkApiHealth } from '@/utils/mixin'
import { asyncRouterMap, suffixRouterMap } from '@/router'
import i18n from '@/lang'

const defaultRouters = [
  '/zhiku/enterprise/terminal-support-analysis',
  '/zhiku/enterprise/model-terminal-support-analysis'
]
// 外加路由
const appendRouters = [
  '/zhiku/ner_xl/model/overview/:id',
  '/zhiku/ner_xl/model/sales/:id',
  '/zhiku/ner_xl/model/price/:id',
  '/zhiku/ner_xl/model/terminal/:id',
  '/zhice/cx/configure/adjust/:step',
  '/zhiku/policy/reports/reportpreview/:id',
  '/zhiku/enterprise/terminal-support-analysis/:id',
  '/zhiku/enterprise/model-terminal-support-analysis/:model_name/:model_id/:ym',
  '/enterprise/model-overview/:manfBrandId',
  '/enterprise/model-terminal-support-analysis/:subModelId/:subModelName/:segmentId/:subSegmentId',
  '/model-conf/custom-model-analysis/view/:id'
]

/**
 * 递归过滤异步路由表
 * @param routes asyncRouterMap
 * @param roles
 */
function filterAsyncRouter(routes, currentRoute) {
  const res = []
  routes.forEach(route => {
    const tmp = { ...route }
    if (tmp.children && tmp.children.length) {
      const children = [...tmp.children]
      tmp.children = filterAsyncRouter(children, currentRoute)
      res.push(tmp)
    } else {
      if (modulePath(route) === modulePath(currentRoute) && currentRoute.path !== '') {
        res.push(tmp)
      }
    }
  })
  return res
}

/**
 * 返回符合用户角色权限的路由表
 * @param routes asyncRouterMap
 * @param roles
 */
function formatRouter(routes, menus) {
  const res = []
  routes.forEach(route => {
    const tmp = { ...route }
    if (tmp.children && tmp.children.length) {
      const children = [...tmp.children]
      tmp.children = formatRouter(children, menus)
      res.push(tmp)
    } else {
      menus.forEach((menu, key) => {
        // 入口路由加载
        if (key === 0) res.push(tmp)
        // 业务菜单路由加载
        if (menu.url.indexOf(route.path) > -1 && route.path !== '') {
          res.push({
            path: menu.url,
            name: menu.title,
            component: route.component,
            meta: route.meta
          })
          for (const i in appendRouters) {
            const path = appendRouters[i]
            const paths = path.split('/:')
            const url = paths.shift()
            const param = ('/:') + paths.join('/:')
            let menuUrl = menu.url
            const findMenuUrl = defaultRouters.find(item => {
              return menuUrl.indexOf(item) > -1
            })
            if (findMenuUrl) {
              menuUrl = findMenuUrl
            }
            if (menuUrl.includes(url)) {
              res.push({
                path: menuUrl + param,
                name: menu.title,
                component: route.component,
                meta: route.meta
              })
              break
            }
          }
        }
      })
    }
  })
  return res
}

/**
 * 当前路由所在模块
 * @param {Array} modules 模块列表
 * @param {Object} route 当前路由
 */
function findCurrentModule(modules, route) {
  const path = modulePath(route)
  const frameUrl = route.query ? route.query.url : ''
  modules = arr2table(modules, 'branches')
  var product
  for (const i in modules) {
    const group = modules[i]
    product = group.funcTreeNodes.find(item => {
      return item.funcUrl === path || item.funcUrl === frameUrl || (item.funcUrl && parseUrl(item.funcUrl).path === path)
    })
    if (product) break
  }
  return product
}

function getInformation({ commit, data }) {
  const { router } = data
  return new Promise((resolve, reject) => {
    getIndexPermission()
      .then(response => {
        const data = response.data.data[0] || false
        if (data) {
          const accessedRouters = filterAsyncRouter(asyncRouterMap, {
            path: '/information'
          })
          // 把菜单url加入路由表
          const addRouters = formatRouter(accessedRouters, [{
            url: '/information',
            title: '信息概览'
          }])
          commit('SET_ROUTERS', { key: '/information', value: { routers: addRouters }})
          router.addRoutes(addRouters) // 动态添加可访问路由表
        } else {
          commit('SET_ROUTERS', { key: '/information', value: '' })
        }
        resolve()
      })
      .catch(error => {
        reject(error)
      })
  })
}

function getReport({ commit, data }) {
  const { router } = data
  // return new Promise((resolve, reject) => {
  //   getIndexPermission()
  //     .then(response => {
  //       const data = response.data.data[0] || false
  //       if (data) {
  const accessedRouters = filterAsyncRouter(asyncRouterMap, {
    path: '/report'
  })
  const t_onlineReport = i18n.messages[i18n.locale].onlineReport
  // 把菜单url加入路由表
  const addRouters = formatRouter(accessedRouters, [
    { url: '/report', title: t_onlineReport.onlineReport },
    { url: '/report/topicReport', title: t_onlineReport.topicReport },
    { url: '/report/projectReport', title: t_onlineReport.projectReport },
    { url: '/report/planReport', title: t_onlineReport.planReport }
  ])
  commit('SET_ROUTERS', {
    key: '/report',
    value: {
      funcId: 9999,
      funcName: t_onlineReport.onlineReport,
      funcUrl: '/report',
      menuTreeNodes: [{
        menuId: 1,
        title: t_onlineReport.onlineReport,
        url: 1,
        funcs: [
          { url: '/report/topicReport', title: t_onlineReport.topicReport, isMenu: true },
          { url: '/report/projectReport', title: t_onlineReport.projectReport, isMenu: true },
          { url: '/report/planReport', title: t_onlineReport.planReport, isMenu: true }

        ]
      }],
      routers: addRouters
    }
  })

  router.addRoutes(addRouters) // 动态添加可访问路由表
  //       } else {
  //         commit('SET_ROUTERS', { key: '/information', value: '' })
  //       }
  //       resolve()
  //     })
  //     .catch(error => {
  //       reject(error)
  //     })
  // })
}

const permission = {
  state: {
    addRouters: {},
    modules: []
  },
  mutations: {
    SET_ROUTERS: (state, { key, value }) => {
      if (key) {
        state.addRouters[key] = value
      } else {
        state.addRouters = value
      }
    },
    SET_MODULES: (state, modules) => {
      state.modules = modules
    }
  },
  actions: {
    // 模块列表
    async GetModules({ commit }, data) {
      return new Promise((resolve, reject) => {
        async function func() {
          await checkApiHealth()
          // 信息概览页权限
          await getInformation({ commit, data })
          // 公开报告
          await getReport({ commit, data })
          // 访问模块列表
          await getListUserFuncs()
            .then(response => {
              const data = response.data.data[0]
              if (data && data.length > 0) {
                commit('SET_MODULES', data)
              }
              resolve(data)
            })
            .catch(error => {
              reject(error)
            })
        }
        func()
      })
    },
    // 模块列表
    async ResetModules({ commit }) {
      // 访问模块列表
      const res = await getListUserFuncs()
      const data = res.data.data[0] || []
      if (data && data.length > 0) commit('SET_MODULES', data)
    },

    GenerateRoutes({ commit }, data) {
      return new Promise((resolve, reject) => {
        const modules = data.modules
        const route = data.route
        // 特殊处理动态路由
        const path = modulePath(route)
        if (['/information', '/report'].includes(path)) {
          if (permission.state.addRouters[path]) {
            resolve()
          } else {
            reject('no module finded!')
          }
        }
        // 找到所属模块
        const currentModule = findCurrentModule(modules, route)
        if (!currentModule) reject('no module finded!')
        // 查找菜单
        getListMenuByFunc({
          funcId: currentModule.funcId
        })
          .then(response => {
            const data = response.data.data[0] || {}
            // 配置可访问路由列表
            const menus = data.menuTreeNodes || []
            const menuData = arr2table(menus, 'funcs')
            // 过滤动态路由表
            const accessedRouters = filterAsyncRouter(asyncRouterMap, route)
            // 把菜单url加入路由表，当route.path=='/frame'时忽略添加路由
            let addRouters = formatRouter(accessedRouters, menuData)
            addRouters = [...addRouters, ...suffixRouterMap]
            // 绑定产品与可访问路由列表
            commit('SET_ROUTERS', { key: currentModule.funcUrl, value: { ...data, routers: addRouters }})
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  }
}

export default permission



// WEBPACK FOOTER //
// ./src/store/modules/permission.js